import { gql } from "@apollo/client";
import { ProjectCardFieldsFragment } from "@govlaunch/project";

export default gql`
  query GroupProjectsPendingVerification($slug: String!, $cursor: Cursor, $limit: Int = 6) {
    groupBySlug(slug: $slug) {
      _id
      projectsPendingVerification(limit: $limit, cursor: $cursor) {
        items {
          _id
          ...ProjectCardFields
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }

  ${ProjectCardFieldsFragment}
`;
